'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sci_IndexedSeq$() {
  this.hO = null;
  $j_java$002elang$002e$002dObject.$ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $j_java$002elang$002e$002dObject.$m_sci_Vector$());
}
export { $c_sci_IndexedSeq$ as $c_sci_IndexedSeq$ };
$p = $c_sci_IndexedSeq$.prototype = new $j_java$002elang$002e$002dObject.$h_sc_SeqFactory$Delegate();
$p.constructor = $c_sci_IndexedSeq$;
/** @constructor */
function $h_sci_IndexedSeq$() {
}
export { $h_sci_IndexedSeq$ as $h_sci_IndexedSeq$ };
$h_sci_IndexedSeq$.prototype = $p;
$p.P0 = (function(it) {
  return ($j_java$002elang$002e$002dObject.$is_sci_IndexedSeq(it) ? it : $j_java$002elang$002e$002dObject.$c_sc_SeqFactory$Delegate.prototype.qY.call(this, it));
});
$p.qY = (function(it) {
  return this.P0(it);
});
$p.aH = (function(source) {
  return this.P0(source);
});
var $d_sci_IndexedSeq$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sci_IndexedSeq$, "scala.collection.immutable.IndexedSeq$", ({
  t5: 1,
  bU: 1,
  a: 1,
  L: 1,
  at: 1
}));
export { $d_sci_IndexedSeq$ as $d_sci_IndexedSeq$ };
var $n_sci_IndexedSeq$;
function $m_sci_IndexedSeq$() {
  if ((!$n_sci_IndexedSeq$)) {
    $n_sci_IndexedSeq$ = new $c_sci_IndexedSeq$();
  }
  return $n_sci_IndexedSeq$;
}
export { $m_sci_IndexedSeq$ as $m_sci_IndexedSeq$ };
